<style lang="less" scoped>
  .member-index {
    width: 100%;
    margin: 0 auto;
    // padding-bottom: 50px;
    height: calc(100vh - 50px);
    overflow-x: auto;
    background: #efefef;
    .activity-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;
      background: #fff;
      border-bottom: 1px solid #efefef;
      .box-value {
        flex: 1;
      }
      .box-handle {
        width: 80px;
        text-align: right;
      }
    }
    .member-info-container {
      background-color: #fff;
      padding: 20px;
      display: flex;
      align-items: center;
      .member-info {
        margin-top: 10px;
        margin-left: 20px;
      }
      .member-email {
        font-size: 16px;
      }
      .member-icon {
        font-size: 60px;
        margin-left: 10px;
      }
    }
  }
  .member-navigation {
    /deep/ .el-menu-item {
      padding: 0 15px;
    }
  }
</style>
<template>
  <div class="member-index">
     <div class="activity-box">
       <div class="box-value">当前登录: {{activity.activityName || ''}}</div>
       <div class="box-handle" @click="showPopupActivity">切换活动</div>
     </div>
      <van-list
        ref="scollElement"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :offset='20'
        :finished-text="list&&list.length? '没有更多了' : ''"
        @load="onLoad"
      >
      <div class="member-info-container flex row flex-cc">
        <svg-icon class="member-icon" icon-class="member" />
        <div class="member-info flex col flex-1">
          <div class="member-email">
            账号: {{currentUser.name}}
          </div>
          <div class="member-address flex flex-sb flex-cc">
            <div>
              <router-link :to="{ name: 'member-member-address'}">
                我的收货地址
              </router-link>
              <!-- <el-button class="select-activity" type="text" @click="showPopupActivity">选择活动</el-button> -->
            </div>
            <el-button type="text" @click="handleLogout">退出登录</el-button>
          </div>
        </div>
      </div>

      <div style="background:white;margin-top:10px;" class="member-navigation">
        <el-menu mode="horizontal" :default-active="activeName" @select="tabClick">
          <el-menu-item index="allOrders">全部订单</el-menu-item>
          <el-menu-item index="unpaidOrders">待付款</el-menu-item>
          <el-menu-item index="unshippingOrders">待发货</el-menu-item>
          <!-- <el-menu-item index="shippingOrders">待收货</el-menu-item> -->
          <el-menu-item index="refundOrders">退款单</el-menu-item>
        </el-menu>
      </div>

      <div v-if="!list || !list.length" style="height:50px;color: #969799;font-size: 14px;" class="flex flex-all-center text-lg">暂无此类型订单</div>
      <OrderListItem  @cancelOrder="cancelOrder" v-for="(order, index) of list" :isRefund="activeName === 'refundOrders' ? true : false" :key="index" :order="order" @getOrders="listGetOrders"/>
      </van-list>
      <div style="height: 50px"></div>
      <van-popup
        v-model="showActivity"
        position="bottom"
      >
        <van-picker
          title=""
          show-toolbar
          value-key='activityName'
          :columns="activityList"
          @confirm="onConfirm"
          @cancel="showActivity=false"
          :default-index='defaultIndex'
          />
      </van-popup>
    <!-- <div class="member-orders">
      <el-tabs value="member-orders" v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="全部订单" name="allOrders" :lazy="true">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无此类型订单</div>
          <OrderListItem v-else @cancelOrder="cancelOrder" v-for="(order, index) of collection" :key="index" :order="order" @getOrders="listGetOrders"/>
        </el-tab-pane>
        <el-tab-pane label="待付款" :lazy="true" name="unpaidOrders">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无此类型订单</div>
          <OrderListItem v-else  v-for="(order, index) of collection" :key="index"  @cancelOrder="cancelOrder" :order="order" @getOrders="listGetOrders" />
        </el-tab-pane>
        <el-tab-pane label="待收货" :lazy="true" name="unshippingOrders">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无此类型订单</div>
          <OrderListItem v-else v-for="(order, index) of collection" :key="index"  :order="order" @getOrders="listGetOrders" />
        </el-tab-pane>
        <el-tab-pane label="退款单" :lazy="true" name="refundOrders">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无退款单</div>
          <OrderListItem v-else v-for="(order, index) of collection" :key="index" :isRefund="true"  :order="order" @getOrders="listGetOrders" />
        </el-tab-pane>
      </el-tabs>
      <div class="pagination">
        <pagination :total="total" :pagination="pagination" :changed="getOrders" />
      </div>
    </div> -->
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash';
  import OrderListItem from "./components/OrderListItem";

  const { mapState: authMapState } = createNamespacedHelpers('auth')
  const { mapGetters } = createNamespacedHelpers('orders')
  const { mapState: activityMapState } = createNamespacedHelpers('activity')

  const limit = 6

  export default {
    name: 'index',
    components: {OrderListItem},
    data() {
      return {
        activeName: 'allOrders',
        loading: false,
        finished: false,
        busy: false,
        list: [],
        showActivity: false,
        defaultIndex: 0
      }
    },
    updated() {
    },
    methods: {
      async onConfirm(data) {
        await this.$store.dispatch('activity/setId', data.id)
        this.$router.go(0)
        this.showActivity=false
      },
      async showPopupActivity() {
        console.log(this.currentUser);
        await this.$store.dispatch('auth/queryActivity', {account: this.currentUser.account})
        this.defaultIndex = this.activityList.findIndex(item => Number(item.id) === Number(this.activityId))
        this.showActivity = true
      },
      async onLoad() {
        const currentPage = this.pagination.currentPage + 1
        await this.getOrders({ pagination: { currentPage, limit } })
        this.loading = false
        if (!this.collection.length) {
          this.finished = true
        } else {
          this.list = this.list.concat(this.collection)
        }
      },
      handleSelect() {

      },
      listGetOrders() {
        const currentPage = this.pagination.currentPage
        this.getOrders({ pagination: { currentPage, limit } })
      },
      cancelOrder(order, status) {
        // const currentPage = this.pagination.currentPage
        // this.getOrders({ pagination: { currentPage, limit } })
        this.list.forEach(item => {
          if (item.orderSn === order.orderSn) {
            item.orderStatus = status
          }
        })
      },
      async tabClick(tab, event) {
        localStorage.removeItem('currentPage')
        localStorage.removeItem('limit')
        localStorage.setItem('activeTabName', tab)
        this.activeName = tab
        this.list = []
        this.finished = false
        this.pagination.currentPage = 1
        await this.getOrders()
        this.list = this.collection
      },
      handleLogout() {
        this.$store.dispatch('auth/logout')
        ysf('logoff')
        this.$router.replace({ name: 'login' })
      },
      async getOrders({ pagination = {limit} } = {}) {
        let query = {};
        switch (this.activeName) {
          case 'unpaidOrders':
            query.orderStatus = this.$enums.orderStatus.UNSETTLED
            query.payStatus = 110
            query.shippingStatus = this.$enums.shippingStatus.UNSHIPPED
            break;
          case 'unshippingOrders':
            query.payStatus = this.$enums.payStatus.PAID
            query.shippingStatus = this.$enums.shippingStatus.UNSHIPPED
            break;
          case 'shippingOrders':
            query.payStatus = this.$enums.payStatus.PAID
            // query.shippingStatus = this.$enums.shippingStatus.SHIPPED
          case 'refundOrders':
            await this.$store.dispatch('orders/loadRefundOrders', { pagination });
            return
          default:
            break;
        }

        const sort = {id: 'desc'}

        await this.$store.dispatch('orders/collection', {query, pagination, sort});
      },
      back() {
        const currentPage = localStorage.getItem('currentPage') ? localStorage.getItem('currentPage') : 0
        const limit = localStorage.getItem('limit') ? localStorage.getItem('limit') : 0
        const activeTabName = localStorage.getItem('activeTabName') ? localStorage.getItem('activeTabName') : 'allOrders'
        this.activeName = activeTabName
        this.getOrders({ pagination: { currentPage, limit } })
      }
    },
    async mounted() {
      await this.getOrders()
      this.list = this.collection
      // console.log(this.$refs.scollElement);
      // window.addEventListener('load', this.back)
    },
    beforeDestroy() {
      localStorage.removeItem('currentPage')
      localStorage.removeItem('limit')
      localStorage.removeItem('activeTabName')
    },
    computed : {
      ...authMapState([
        'currentUser', 'activityList'
      ]),

      ...mapGetters([
        'collection',
        'total',
        'pagination']
      ),
      ...activityMapState([
        'activityId', 'activity'
      ])
    },
    watch : {

    }
  };
</script>


